export default [
  {
    path: '/operatingReports', name: 'operatingReports', component: () => import('@/pages/operatingReports/operatingReports'), meta: { title: '运营报表' },
  },
  {
    path: '/incomeAnalysis', name: 'incomeAnalysis', component: () => import('@/pages/operatingReports/incomeAnalysis'), meta: { title: '收入分析' },
  },
  {
    path: '/machineAnalysis', name: 'machineAnalysis', component: () => import('@/pages/operatingReports/machineAnalysis'), meta: { title: '设备分析' },
  },
  {
    path: '/machineAnalysisDetail', name: 'machineAnalysisDetail', component: () => import('@/pages/operatingReports/machineAnalysisDetail'), meta: { title: '设备分析' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/operatingReports.js